const Hash = () => (
  <svg
    width="15px"
    height="15px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.226 1.214a.917.917 0 0 0-1.76-.516L5.38 4.396H1.008a.917.917 0 0 0 0 1.834h3.834l-1.04 3.54H1.007a.917.917 0 1 0 0 1.834h2.255l-.935 3.182a.917.917 0 1 0 1.759.517l1.087-3.7h3.534l-.934 3.183a.917.917 0 1 0 1.759.517l1.086-3.7h4.372a.917.917 0 0 0 0-1.832h-3.833l1.04-3.541h2.793a.917.917 0 0 0 0-1.834h-2.254l.934-3.182a.917.917 0 0 0-1.759-.516l-1.086 3.698H7.29l.935-3.182Zm1.021 8.557 1.04-3.541H6.752l-1.04 3.54h3.535Z"
      fill="#fff"
    />
  </svg>
);

export default Hash;
